<div class="business-navbar__modal__header" [ngClass]="{'business-navbar__modal__header--mobile': (isMobile$ | async)}">
    <ng-content></ng-content>
</div>
